import { GET } from './api'

export const ReadCompanyOptions = async ({ query = '', page = 1, pageSize = 30 } = {}) => {
  const params = new URLSearchParams({
    query: query || '',
    page: String(page),
    pageSize: String(pageSize),
  })
  return await GET(`/companies/select?${params.toString()}`, true)
}
